import(/* webpackMode: "eager", webpackExports: ["Shell"] */ "/work/apps/dashboard/src/app/_layout/Shell.tsx");
;
import(/* webpackMode: "eager" */ "/work/packages/tokens/dist/tokens.css");
;
import(/* webpackMode: "eager" */ "/work/packages/mascot/dist/mascot.css");
;
import(/* webpackMode: "eager" */ "/work/packages/ui/dist/ui.css");
;
import(/* webpackMode: "eager" */ "/work/apps/dashboard/src/app/globals.css");
